import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.list-unmatched-statement-items.views.UnmatchedStatementItemsPane`

export default defineMessages({
  paneTitle: {
    id: `${scope}.paneTitle`,
    defaultMessage: 'Credit card statement items',
  },
  searchPlaceholder: {
    id: `${scope}.searchPlaceholder`,
    defaultMessage: 'Search for credit card statement items',
  },
  sortDateLabel: {
    id: `${scope}.sortDateLabel`,
    defaultMessage: 'Date',
  },
  sortTotalCostLabel: {
    id: `${scope}.sortTotalCostLabel`,
    defaultMessage: 'Total cost',
  },
  sortDescriptionLabel: {
    id: `${scope}.sortDescriptionLabel`,
    defaultMessage: 'Description',
  },
  suggestedFilterBanner: {
    id: `${scope}.suggestedFilterBanner`,
    defaultMessage: 'Showing suggested matches for the selected Procurify item',
  },
  clearFilterButton: {
    id: `${scope}.clearFilterButton`,
    defaultMessage: 'Clear filter',
  },
  emptyStateHeader: {
    id: `${scope}.emptyStateHeader`,
    defaultMessage: 'There are no unmatched statement items',
  },
  selectRowAriaLabel: {
    id: `${scope}.selectRowAriaLabel`,
    defaultMessage: 'Select {description}',
  },
  justCreatedTag: {
    id: `${scope}.justCreatedTag`,
    defaultMessage: 'Just created',
  },
})
